import { APIRoute } from '@/modules/utils'
import { RecursivePartial } from '@/utils'
import { ConnectedUser } from '@/dataV3/User/ConnectedUser'
import { AuthReturn } from '@/modules/Auth/apiTypes/base'

export const Route: APIRoute = {
  method: 'PUT',
  path: '/members/account',
}

export type Body = RecursivePartial<ConnectedUser>

export type Response = ConnectedUser & AuthReturn
